import type { Dispatch, FormEvent, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { MCP_CONNECTOR_CATALOG } from '../../catalogs.js';

interface PartnerConnectorTabProps {
  connectorKeys: string[];
  busy: boolean;
  setConnectorKeys: Dispatch<SetStateAction<string[]>>;
  onSave: (event: FormEvent) => void;
}

export function PartnerConnectorTab({ connectorKeys, busy, setConnectorKeys, onSave }: PartnerConnectorTabProps) {
  const { t } = useTranslation();
  return (
    <section className="panel">
      <h3>{t('partners.connectorScope')}</h3>
      <form onSubmit={onSave}>
        <div className="model-list">
          {MCP_CONNECTOR_CATALOG.map((connector) => (
            <label key={connector.id} className="check-row">
              <input
                type="checkbox"
                checked={connectorKeys.includes(connector.id)}
                onChange={(event) =>
                  setConnectorKeys((current) =>
                    event.target.checked ? [...new Set([...current, connector.id])] : current.filter((id) => id !== connector.id)
                  )
                }
              />
              <span>
                <strong>{connector.label}</strong>
                <small>{connector.id}</small>
              </span>
            </label>
          ))}
        </div>
        <div className="form-actions">
          <button disabled={busy}>{t('partners.saveConnectorScope')}</button>
        </div>
      </form>
      <p className="muted">{t('partners.connectorScopeHint')}</p>
    </section>
  );
}
